import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import PublicLayout from "@/layouts/PublicLayout";
import AdminLayout from "@/layouts/AdminLayout";
import Home from "@/pages/public/Home";
import About from "@/pages/public/About";
import DomesticTours from "@/pages/public/DomesticTours";
import InternationalTours from "@/pages/public/InternationalTours";
import GroupTours from "@/pages/public/GroupTours";
import Contact from "@/pages/public/Contact";
import PackageDetails from "@/pages/public/PackageDetails";
import AdminDashboard from "@/pages/admin/Dashboard";
import ItineraryList from "@/pages/admin/ItineraryList";
import ItineraryWizard from "@/pages/admin/ItineraryWizard";
import ItineraryEditor from "@/pages/admin/ItineraryEditor";
import PackagesManager from "@/pages/admin/PackagesManager";
import InquiriesPage from "@/pages/admin/Inquiries";
import PrintItinerary from "@/pages/admin/PrintItinerary";
import SharedItinerary from "@/pages/public/SharedItinerary";

import HotelsManager from "@/pages/admin/HotelsManager";
import AccountingDashboard from "@/pages/admin/AccountingDashboard";
import PrintLedger from "@/pages/admin/PrintLedger";

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors />
      <Routes>
        {/* PUBLIC */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/domestic" element={<DomesticTours />} />
          <Route path="/international" element={<InternationalTours />} />
          <Route path="/group" element={<GroupTours />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/package/:id" element={<PackageDetails />} />
        </Route>

        {/* ADMIN (no auth in v1) */}
        <Route element={<AdminLayout />}>
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/itineraries" element={<ItineraryList />} />
          <Route path="/admin/itineraries/new" element={<ItineraryWizard />} />
          <Route path="/admin/itineraries/:id" element={<ItineraryEditor />} />
          <Route path="/admin/packages" element={<PackagesManager />} />
          <Route path="/admin/hotels" element={<HotelsManager />} />
          <Route path="/admin/accounting" element={<AccountingDashboard />} />
          <Route path="/admin/inquiries" element={<InquiriesPage />} />
        </Route>

        {/* PRINT (isolated layout) */}
        <Route path="/print/:id" element={<PrintItinerary />} />
        <Route path="/print-ledger" element={<PrintLedger />} />

        {/* SHARED ITINERARY (public, no layout) */}
        <Route path="/share/:token" element={<SharedItinerary />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
